export const INVOICE_BANK = {
    MITSUBISHI : {
        invoice_bank_branch_name : "あさぎり",
        invoice_bank_account_kana : "ｶ)ﾗﾝﾄﾞﾏ-ｸ",
        invoice_bank_account_type : 1,
        invoice_bank_account_number : null,
    },
    SUMITOMO : {
        invoice_bank_branch_name : "赤坂",
        invoice_bank_account_kana : "ｶ)ﾗﾝﾄﾞﾏ-ｸ",
        invoice_bank_account_type : 1,
        invoice_bank_account_number : "9082384",
    },
    NONE : {
        invoice_bank_branch_name : null,
        invoice_bank_account_kana : null,
        invoice_bank_account_type : null,
        invoice_bank_account_number : null,
    }
}